import React, { PureComponent } from "react";
import { Tab, Tabs } from "react-bootstrap";

import './StylingHelp.scss';

const variables = [
    { name: "odd-row-color", type: "color", description: "Row color for odd numbered rows (starting with the first row)"},
    { name: "even-row-color", type: "color", description: "Row color for even numbered rows (starting with the second row)"},
    { name: "positive-change-color", type: "color", description: "Text color for futures change values when positive"},
    { name: "negative-change-color", type: "color", description: "Text color for futures change values when negative"},

    { name: "name-column-width", type: "size", description: "Column width for the Name column"},
    { name: "date-column-width", type: "size", description: "Column width for the Date column"},
    { name: "month-column-width", type: "size", description: "Column width for the Month column"},
    { name: "price-column-width", type: "size", description: "Column width for the Price column"},
    { name: "basis-column-width", type: "size", description: "Column width for the Basis column"},
    { name: "cash-column-width", type: "size", description: "Column width for the Cash column"},
    { name: "change-column-width", type: "size", description: "Column width for the Change column"},
    
    { name: "table-font-size", type: "size", description: "Font size for table contents"},
]

export default class StylingHelp extends PureComponent {
    render() {
        return <div className="styling-help">

            <Tabs defaultActiveKey="variables" id="styling-help-tabs">
                <Tab eventKey="variables" title="Variables">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {variables.map(m => <tr key={m.name}>
                                <td className="text-monospace">--{m.name}</td>
                                <td>{m.type}</td>
                                <td>{m.description}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </Tab>
                <Tab eventKey="layout" title="Layout">
                    <pre>
                        --- .stonex-bids-component -------{'\n'}
                        |                                |{'\n'}
                        |  --- .bid-group -------------  |{'\n'}
                        |  |                          |  |{'\n'}
                        |  | .bid-group-name          |  |{'\n'}
                        |  |                          |  |{'\n'}
                        |  |  --- .bid-table -------  |  |{'\n'}
                        |  |  |                    |  |  |{'\n'}
                        |  |  | .bid-table-name    |  |  |{'\n'}
                        |  |  |                    |  |  |{'\n'}
                        |  |  | .bid-table-header  |  |  |{'\n'}
                        |  |  | .bid-table-row     |  |  |{'\n'}
                        |  |  | .bid-table-row     |  |  |{'\n'}
                        |  |  ----------------------  |  |{'\n'}
                        |  |                          |  |{'\n'}
                        |  |  --- .bid-table -------  |  |{'\n'}
                        |  |  |                    |  |  |{'\n'}
                        |  |  | .bid-table-name    |  |  |{'\n'}
                        |  |  |                    |  |  |{'\n'}
                        |  |  | .bid-table-header  |  |  |{'\n'}
                        |  |  | .bid-table-row     |  |  |{'\n'}
                        |  |  | .bid-table-row     |  |  |{'\n'}
                        |  |  ----------------------  |  |{'\n'}
                        |  ----------------------------  |{'\n'}
                        |                                |{'\n'}
                        |  --- .bid-group -------------  |{'\n'}
                        |  | (etc.)                   |  |{'\n'}
                        |  ----------------------------  |{'\n'}
                        |                                |{'\n'}
                        ----------------------------------{'\n'}
                    </pre>
                </Tab>
            </Tabs>
        </div>;
    }
}